import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DatetimeHelper } from 'src/app/_core/helpers/datetime.helper';
import { CommonService } from 'src/app/_core/services/common.service';
import { pageTransition } from 'src/app/shared/utils/animations';
import { Images } from 'src/assets/data/images';
import { AlertType } from '../../../shared/components/alert/alert.type';
import { PublicRoutes } from '../../public.routes';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import { AuthService } from '../auth.service';
import Swal from 'sweetalert2';
import { User } from 'src/app/_core/models/user';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css'],
  animations: [pageTransition],
})
export class SigninComponent implements OnInit {
  readonly signinBannerImage: string = Images.bannerLogo;

  isLoading: boolean = false;
  readonly publicRoutes = PublicRoutes;
  readonly currentYear: number = DatetimeHelper.currentYear;

  serverErrors: string[] = [];
  signInForm!: FormGroup;
  submitted = false;
  hidePassword = true;
  hidePrincipalPassword = true;
  hideNewPassword = true;
  error: string | null = null;
  itemsUser: any = [];
  itemToSave: any;

  showModal: boolean = false;
  loading: boolean = false;
  changePassword!: FormGroup;
  loginEmail: string = '';
  showModalPassWord: boolean = false;
  currentUser: any
  user: any

  loginForm = this.formBuilder.group({
    email: ['',  [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  ngOnInit() {
    
    const currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
    const currentUserEmail = currentUser.email || '';
    console.log("mon email",currentUserEmail);
    

    this.authService.currentUser.subscribe((user : User)=> {
      console.log('Component received user update:', user);
      this.currentUser = user;
    });
    
    // Also log the direct value
    console.log('Direct currentUserValue:', this.authService.currentUserValue);

    this.signInForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    
    this.changePassword = this.formBuilder.group({
      email: [''],
      oldMotDePasse: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  constructor(
    public commonService: CommonService,
    private formBuilder: FormBuilder,
    private router: Router,
    private utilities: UtilitiesService,
    private authService: AuthService
  ) {}

  
  protected readonly AlertType = AlertType;

  protected onFormSubmitHandler = (event: SubmitEvent) => {
    event.preventDefault();
    this.isLoading = true;

    setTimeout(() => {
      this.isLoading = false;
      // this.router.navigate([PublicRoutes.Otp]);
      this.router.navigate([PublicRoutes.Signin], { 
        state: { email: this.signInForm.value.email } 
      });
    }, 2000);
  };

  openModal(user: any) {
    this.showModal = true;
    this.changePassword.patchValue({
      email: user.email,
    });
  }

  protected onAlertCloseHandler = (e: any) => {
    this.serverErrors = [];
  };

  get f() {
    return this.signInForm.controls;
  }
  togglePrincipalPasswordVisibility(): void {
    this.hidePrincipalPassword = !this.hidePrincipalPassword;
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }
  toggleNewPasswordVisibility(): void {
    this.hideNewPassword = !this.hideNewPassword;
  }
  onSubmit() {
    this.isLoading = true;
    this.submitted = true;
    

    if (this.signInForm.invalid) {
      this.utilities.showNotification(
        'Email et mot de passe sont requis et doivent être valides.',
        'error'
      );
      this.isLoading = false;
      return;
    }

    const { email, password } = this.signInForm.value;

    this.authService.login(email, password).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        console.log('Réponse reçue:', res);

        this.itemsUser = res.items;

        if (res.item?.isDefaultPassword === true) {
          this.loginEmail = res.item?.email || res.item?.email || email;
          this.changePassword.patchValue({
            email: this.loginEmail,
          });

          this.showModal = true;
          this.isLoading = false;
          return;
        }

        if (res && !res['hasError']) {
          this.utilities.showNotification(res.status?.message, 'success');
          this.router.navigate([PublicRoutes.Otp]);
        } else {
          this.utilities.showNotification(
            res.status?.message || 'Erreur lors de la connexion',
            'error'
          );
        }
      },
      error: (error) => {
        console.error('Erreur HTTP:', error);
        this.utilities.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  onShowModal() {
    this.showModal = true;
  }

  onShowModalpwd() {
    this.showModalPassWord = true;
  }

  closeModal() {
    this.showModal = false;
  }

  get changePasswordControls(): { [key: string]: AbstractControl } {
    return this.changePassword ? this.changePassword.controls : {};
  }

  hasError(controlName: string, errorType: string): boolean {
    const control = this.changePasswordControls[controlName];
    return control ? this.submitted && control.hasError(errorType) : false;
  }

  confirmSave() {
    this.submitted = true;

    if (this.changePassword.invalid) {
      this.utilities.showNotification(
        'Veuillez remplir correctement tous les champs',
        'error'
      );
      return;
    }

    this.saveItem();

  }

  saveItem() {
    if (this.changePassword.invalid) {
      this.utilities.showNotification(
        'Veuillez corriger les erreurs du formulaire',
        'error'
      );
      return;
    }

    const email = this.changePassword.get('email')?.value;
    const oldMotDePasse = this.changePassword.get('oldMotDePasse')?.value;
    const password = this.changePassword.get('password')?.value;

    this.authService
      .changePassWord(email, password, oldMotDePasse)
      .subscribe({
        next: (res: any) => {
          if (res && !res['hasError']) {
            this.utilities.showNotification(
              'Mot de passe modifié avec succès',
              'success'
            );
            this.closeModal();
            window.location.reload();
            this.router.navigate([PublicRoutes.Signin]);
          } else {
            this.utilities.showNotification(
              res['status']?.message ||
                'Échec de la modification du mot de passe',
              'error'
            );
          }
        },
        error: (error) => {
          console.error('Erreur lors du changement de mot de passe:', error);
          this.utilities.showNotification(
            'Une erreur est survenue lors du changement de mot de passe',
            'error'
          );
        },
      });
  }

  
}
